// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ce9c95ed","453":"a9f905bb","455":"3f7fb347"}[chunkId] + ".chunk.js";
};